import { render, staticRenderFns } from "./PublicationPreviewAvatar.vue?vue&type=template&id=bb33721c&scoped=true&"
import script from "./PublicationPreviewAvatar.vue?vue&type=script&lang=js&"
export * from "./PublicationPreviewAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb33721c",
  null
  
)

export default component.exports